/* ============================================================
   SHINE & STYLE — variant picker

   The authoritative control is <select name="id">. These styled
   buttons only drive it, so with JavaScript off the select is still
   in the form and the product is still buyable — which also keeps
   EasySell COD working, since it reads the standard product form.
   ============================================================ */
(function () {
  'use strict';

  var form = document.querySelector('[data-variant-select]');
  if (!form) return;

  var select = form;
  var options = Array.prototype.slice.call(select.options);
  var addButton = document.querySelector('[data-add-button]');
  var priceOut = document.querySelector('[data-price]');
  var compareOut = document.querySelector('[data-compare]');
  var buybarPrice = document.querySelector('.ss-buybar__price');

  /* What the shopper has picked, by option position. */
  var chosen = {};
  var selected = options.filter(function (o) { return o.selected; })[0];
  if (selected) {
    chosen[1] = selected.getAttribute('data-option1');
    chosen[2] = selected.getAttribute('data-option2');
  }

  function findVariant() {
    for (var i = 0; i < options.length; i++) {
      var o = options[i];
      var one = o.getAttribute('data-option1');
      var two = o.getAttribute('data-option2');
      var matchOne = !chosen[1] || chosen[1] === one;
      var matchTwo = !chosen[2] || chosen[2] === two;
      if (matchOne && matchTwo) return o;
    }
    return null;
  }

  /* Grey out sizes that do not exist in the chosen colour, rather than
     letting someone pick a combination the store cannot sell. */
  function refreshAvailability() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-option-position="2"]'),
      function (btn) {
        var value = btn.getAttribute('data-option-value');
        var sellable = options.some(function (o) {
          return o.getAttribute('data-option2') === value &&
                 (!chosen[1] || o.getAttribute('data-option1') === chosen[1]) &&
                 o.getAttribute('data-available') === 'true';
        });
        btn.disabled = !sellable;
      }
    );
  }

  /* The one place that decides what the buy buttons say and whether
     they work.

     It writes data-sold-out as well as `disabled`, because two other
     scripts read that attribute and have to agree with this one:
     ss-cart.js picks the label from it, and EasySell watches the
     add button's disabled state to decide whether to offer its
     cash-on-delivery form at all. Three readers, one source. */
  function setBuyState(available) {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-add-button], .ss-buybar button[name="add"]'),
      function (b) {
        b.disabled = !available;
        if (available) b.removeAttribute('data-sold-out');
        else b.setAttribute('data-sold-out', '');

        var label = b.getAttribute(available ? 'data-label-add' : 'data-label-sold');
        if (label) b.textContent = label;
      }
    );
  }

  function apply() {
    var match = findVariant();

    /* A colour and a size that pair to no variant at all. This used
       to return early and leave the buttons saying "Add to your
       collection" while disabled - a live-looking button for a
       combination the shop cannot sell. */
    if (!match) { setBuyState(false); return; }

    select.value = match.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    if (priceOut) priceOut.textContent = match.getAttribute('data-price');

    var cmp = match.getAttribute('data-compare');
    if (compareOut) {
      // Shopify renders an empty compare-at as $0.00, not blank.
      var hasCompare = cmp && cmp.replace(/[^0-9]/g, '') !== '' && cmp.indexOf('0.00') === -1;
      compareOut.textContent = hasCompare ? cmp : '';
      compareOut.hidden = !hasCompare;
    }

    if (buybarPrice) buybarPrice.textContent = match.getAttribute('data-price');

    /* Show the photograph that belongs to the variant.

       Picking a colour and being left looking at the previous one
       is the single most confusing thing a colour picker can do -
       the shopper has no way to tell whether the pick registered.

       Done by clicking the matching thumbnail rather than by
       toggling classes here, so the gallery keeps one owner: the
       active slide, the thumbnail's current state and anything else
       show() does all stay in step. If the variant has no photo of
       its own, the gallery is left where it is rather than being
       reset to the first frame. */
    var mediaId = match.getAttribute('data-media-id');
    if (mediaId) {
      var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + mediaId + '"]');
      if (thumb) {
        thumb.click();
      } else {
        /* One photograph, so no thumbnails to click. */
        var slides = document.querySelectorAll('[data-gallery-stage] img');
        Array.prototype.forEach.call(slides, function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-media-id') === mediaId);
        });
      }
    }

    /* Relabelled both buttons, not just the in-page one - the buy
       bar carried the old wording down the page while the button
       above it already said Sold out. */
    setBuyState(match.getAttribute('data-available') === 'true');

    refreshAvailability();

    // Keep the URL in step so the variant can be linked and shared.
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url);
    }
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-option-value]'), function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      var position = btn.getAttribute('data-option-position');
      var value = btn.getAttribute('data-option-value');
      chosen[position] = value;

      Array.prototype.forEach.call(
        document.querySelectorAll('[data-option-position="' + position + '"]'),
        function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); }
      );

      var out = document.querySelector('[data-option-out="' + position + '"]');
      if (out) out.textContent = value;

      apply();
    });
  });

  // Someone using the raw select (no JS styling, or a screen reader)
  // should still move the rest of the UI.
  select.addEventListener('change', function () {
    var o = options.filter(function (x) { return x.value === select.value; })[0];
    if (!o) return;
    chosen[1] = o.getAttribute('data-option1');
    chosen[2] = o.getAttribute('data-option2');
    if (priceOut) priceOut.textContent = o.getAttribute('data-price');
  });

  refreshAvailability();
})();
